var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('span',{class:((_vm.isActive ? '' : 'active') + " button-see-more"),on:{"click":function (){ return _vm.toggleTip(); }}},[_vm._v(_vm._s(_vm.isActive ? "See less" : "See more"))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }